import PropTypes from 'prop-types';
import React from 'react';
import StyledSwatch from './styled-swatch';

const { forwardRef } = React;

const propTypes = {
	className: PropTypes.string,
	dataTestId: PropTypes.string,
	imageSrc: PropTypes.string,
	colour: PropTypes.string,
	size: PropTypes.oneOfType([
		PropTypes.oneOf(['small', 'medium', 'large']),
		PropTypes.shape({
			xxs: PropTypes.string,
			xs: PropTypes.string,
			s: PropTypes.string,
			m: PropTypes.string,
			l: PropTypes.string,
			xl: PropTypes.string,
			xxl: PropTypes.string,
		}),
	]),
};

const defaultProps = {
	className: undefined,
	dataTestId: null,
	imageSrc: null,
	colour: null,
	size: 'medium',
};

const Swatch = forwardRef(({ dataTestId, imageSrc, colour, className, ...props }, ref) => (
	<StyledSwatch
		className={className}
		data-testid={dataTestId}
		imageSrc={imageSrc}
		colour={colour}
		ref={ref}
		{...props}
	/>
));

Swatch.propTypes = propTypes;
Swatch.defaultProps = defaultProps;

export { Swatch };

export default Swatch;
